import { FieldErrors, UseFormSetFocus, Path } from 'react-hook-form';
import { GuestRoomsFormData } from '../organisms/GuestRooms/GuestRooms.types';
import { EventSpacesFormData } from '../organisms/EventSpaces/EventSpaces.types';
import { BillingAndContactFormData } from '../organisms/BillingAndContact/BillingAndContact.types';

type FormType = GuestRoomsFormData | EventSpacesFormData | BillingAndContactFormData;
export const focusFirstError = (errors: FieldErrors<FormType>, setFocus: UseFormSetFocus<FormType>) => {
  //  Build full path (handles missing ref.name)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const findFirstError = (obj: Record<string, any>, parent = ''): string | null => {
    for (const key of Object.keys(obj)) {
      const value = obj[key];
      const path = parent ? `${parent}.${key}` : key;

      if (value?.ref?.name) return value.ref.name;

      if (value?.type) return path;

      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          if (!value[i]) continue;
          const nested = findFirstError(value[i], `${path}.${i}`);
          if (nested) return nested;
        }
      }

      if (value && typeof value === 'object') {
        const nested = findFirstError(value, path);
        if (nested) return nested;
      }
    }
    return null;
  };

  const fieldName = findFirstError(errors);
  if (!fieldName) return;

  const [root, index] = fieldName.split('.');

  //  RHF focus (fallback)
  setFocus(fieldName as Path<FormType>);

  setTimeout(() => {
    let container: HTMLElement | null = null;

    //  HANDLE RADIO GROUPS

    if (root === 'eventType') {
      container = document.querySelector('[data-testid="groups-EventType"]');
    }

    if (root === 'billingType') {
      container = document.querySelector('[data-testid="groups-BillingTypeSelection"]');
    }

    if (root === 'eventSpaces') {
      // find all sections
      const sections = document.querySelectorAll('[data-testid="groups-EventSpaceConfigurationPicker"]');

      if (sections.length && index !== undefined) {
        container = sections[Number(index)] as HTMLElement;
      }
    }

    //  GENERIC INPUTS / TEXTAREA
    if (!container) {
      const field = document.querySelector(`[name="${CSS.escape(fieldName)}"]`) as HTMLElement | null;

      container = field?.closest('.m-input-field') || field?.closest('[data-component-name]') || field;
    }

    if (!container) return;

    //  SCROLL
    container.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });

    //  FOCUS
    setTimeout(() => {
      let focusable: HTMLElement | null = null;

      if (container) {
        //  For radio groups → focus visible span
        focusable = container.querySelector('span[role="radio"], [tabindex="0"]') as HTMLElement;

        // fallback inputs
        if (!focusable) {
          focusable = container.querySelector('input:not([tabindex="-1"]), textarea') as HTMLElement;
        }

        focusable?.focus();
      }
    }, 300);
  }, 120);
};
